module.exports = __webpack_public_path__ + "static/img/logo.189b904.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/logo.png
// module id = w2uv
// module chunks = 8